import React from 'react';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

type OwnProps = {
  className?: string;
  link: string;
  name: string;
};

const StoreLink = React.memo(({ className, link, name }: OwnProps) =>
  link && name ? (
    <S.StoreInfoLink to={link} data-test="StoreInfoLink" className={className}>
      <T domain="product" store_name={name}>
        store-info.more-about-store
      </T>
    </S.StoreInfoLink>
  ) : null
);

export default StoreLink;
